import {store} from 'app/store';
import {getJWT} from 'modules/auth/selectors';

const buildQuery = (obj) => {
    let str = [];
    for(let p in obj)
        str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
    return str.join('&');
};

const throwServerError = (response) => (body) => {
    let error = new Error(response.statusText);
    error.response = response;
    error.body = body.body || body;
    throw error;
};

const status = (response) => {
    if (response.status >= 200 && response.status < 300) {
        return Promise.resolve(response);
    } else {
        return response.json()
            .then(throwServerError(response))
            .catch(throwServerError(response));
    }
};

const json = (response) => {
    if (response.status !== 204) {
        return response.json();
    }
    return response;
};

const handleServerResponse = (promise) => promise.then(status).then(json);

const buildHeaders = (jwtHeader=true) => {
    const jwt = jwtHeader && getJWT(store.getState());
    let headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    };

    if (jwt) {
        headers.Authorization = `Bearer ${jwt}`;
    }
    return new Headers(headers);
};

export const post = (route, body, {method='post', jwtHeader=true} = {}) => {
    let request = new Request(route, {
        method: method,
        mode: 'cors',
        headers: buildHeaders(jwtHeader),
        body: JSON.stringify(body)
    });
    return () => handleServerResponse(fetch(request));
};

export const put = (route, body) => {
    return post(route,body,{method:'put'});
};

export const get = (route, {method='get',query=null} = {}) => {
    if (query) {
        route = route + '?' + buildQuery(query);
    }
    let request = new Request(route, {
        method: method,
        headers: buildHeaders()
    });
    return () => handleServerResponse(fetch(request));
};

export const del = (route) => {
    return get(route,{method:'delete'});
};

export const uploadFile = (route, data) => {
    const jwt = getJWT(store.getState());
    let headers = {};
    if (jwt) {
        headers.Authorization = `Bearer ${jwt}`;
    }
    
    return fetch(route, {
        method: 'POST',
        body: data,
        headers: new Headers(headers)
    });
};